import React from 'react'
import { Link, useMatch, useParams } from 'react-router-dom'
import ProjectFolderIcon from '../../assets/ProjectFolderIcon'

export default function Breadcrumbs({ children }: { children?: React.ReactNode }) {
  const { org, project } = useParams()
  const match = useMatch('/:org/:project/*')
  // const rest = match?.params['*'] || ''
  const rest = (match?.params['*']?.split('modeler/')[0] || '').replace(/\/$/, '') // ovo izbacuje modeler ako je na kraju... ali malo cudno kod modelera ako editujes bpmn fajl ovaj kod je nepotreban a ako editujes dmn/form ovaj kod je potreban :D
  const parts = rest.split('/').filter(Boolean)
  const cumulativePaths = parts.map((_, i) => `/${org}/${project}/${parts.slice(0, i + 1).join('/')}`)

  return (
    <div className='font-sans flex items-center text-[20px] text-[#262A38]'>
      <Link to={`/${org}`}>
        <ProjectFolderIcon className='w-6 h-6 mr-3' fill='#636A7E' />
      </Link>
      <Link to={`/${org}/${project}`} className='hover:underline'>
        / {project}
      </Link>
      {parts.map((part, i) => (
        <span key={i}>
          {' / '}
          <Link to={cumulativePaths[i]} className='hover:underline'>
            {part}
          </Link>
        </span>
      ))}
      {children && (
        <span>
          {' / '}
          {children}
        </span>
      )}
    </div>
  )
}
